<template>
  <vue-modal id="otherReservationModal"
             :name="MODAL"
             classes="vue-modal-container"
             height="auto"
             width="360px"
             @before-open="beforeModalOpen">
    <div class="header">
      <h3>{{ trans.header }}</h3>
      <div class="sub-title">{{ subjectTypeName }} / {{ startTime }}</div>
      <button class="close-modal"
              @click="$modal.hide(MODAL)">
        <i class="close icon"/>
      </button>
    </div>
    <div :set="clubInfo = pfClientActive ? partnersAt(startTime) : {}"
         class="content">
      <div class="extra-outer">
        <cancel-notification-extra v-if="cancelNotifClientActive"
                                   :from_time='startTime'
                                   :subjectId='subjectId'
                                   :subjectTypeName="subjectTypeName"/>
      </div>

      <div class="extra-outer">
        <partner-finder-extra v-if="pfClientActive"
                              :clubInfo="clubInfo"
                              :from_time="startTime"
                              :subject_id="subjectId"/>
      </div>

    </div>
  </vue-modal>
</template>

<script>
import {mapGetters, mapState} from 'vuex'
import PartnerFinderExtra from '@/components/partnerFinder/PartnerFinderExtra';
import CancelNotificationExtra from '@/components/cancelNotification/CancelNotificationExtra';
import {pfGetClientActive, pfGetPartnersAt} from '../../store/partnerFinder';
import {cnGetClientActive} from '../../store/cancelNotification';

export const MODAL = 'other-reservation-modal';

export default {
  props: [],
  data: () => ({
    startTime: null, subjectId: null, subjectName: null, subjectTypeName: null,
  }),
  methods: {
    beforeModalOpen (event) {
      this.startTime = event.params.startTime;
      this.subjectId = event.params.subjectId;
      this.subjectName = event.params.subjectName;
      this.subjectTypeName = event.params.subjectTypeName;
    },
  }, // methods
  computed: {
    MODAL: () => MODAL,
    ...mapState({
      trans: state => state.trans.otherReservationModal,
    }),
    ...mapGetters({
      pfClientActive: pfGetClientActive,
      partnersAt: pfGetPartnersAt,
      cancelNotifClientActive: cnGetClientActive,
    }),
  },
  components: {
    PartnerFinderExtra,
    CancelNotificationExtra,
  },
}
</script>
<style scoped>
.extra-outer:not(:first-child) {
  border-top: 1px solid #9c9c9c;
  margin-top: .5em;
  padding-top: 1em;
}


</style>
